import { FileText, Palette, LayoutTemplate, MousePointerClick, Sparkles } from "lucide-react";

export const PLATFORMS = [
  {
    id: "google-sites", icon: FileText, color: "from-sky-300 to-blue-500", url: "https://sites.google.com",
    name: "Google Sites", level: 1, free: true,
    es: "La más fácil: arrastras textos y fotos como en una presentación.",
    en: "The easiest: drag text and photos like in a slideshow.",
  },
  {
    id: "canva", icon: Palette, color: "from-fuchsia-300 to-violet-500", url: "https://www.canva.com/websites/",
    name: "Canva Sites", level: 1, free: true,
    es: "Diseña tu web bonita con plantillas y la publicas con un clic.",
    en: "Design a pretty site with templates and publish in one click.",
  },
  {
    id: "carrd", icon: MousePointerClick, color: "from-lime-300 to-green-500", url: "https://carrd.co",
    name: "Carrd", level: 2, free: true,
    es: "Perfecta para una web de una sola página para tu negocio.",
    en: "Perfect for a one-page site for your business.",
  },
  {
    id: "wix", icon: LayoutTemplate, color: "from-amber-300 to-orange-500", url: "https://www.wix.com",
    name: "Wix", level: 2, free: true,
    es: "Muchas plantillas y una tienda para vender en línea.",
    en: "Lots of templates and a store to sell online.",
  },
  {
    id: "emergent", icon: Sparkles, color: "from-rose-300 to-pink-500", url: "https://emergent.sh",
    name: "Emergent", level: 3, free: true,
    es: "Le describes tu idea a la IA y te construye la web o la app.",
    en: "Describe your idea to AI and it builds the website or app.",
  },
];

export const GLOSSARY = [
  { id: "domain", color: "bg-yellow-200", es: ["Dominio", "Es la dirección de tu web, como la dirección de tu casa. Ej: galletasmagicas.com"], en: ["Domain", "Your website's address, like your home address. E.g. magiccookies.com"] },
  { id: "hosting", color: "bg-sky-200", es: ["Hosting", "Es el terreno en internet donde vive tu web para que todos la visiten."], en: ["Hosting", "The land on the internet where your website lives so everyone can visit."] },
  { id: "platform", color: "bg-pink-200", es: ["Plataforma", "Son las herramientas para construir tu web sin saber programar. ¡Muchas ya incluyen hosting gratis!"], en: ["Platform", "Tools to build your site without coding. Many include free hosting!"] },
];

export const PROMPTS = {
  es: [
    "Explícame qué es un dominio y un hosting como si tuviera 8 años.",
    "¿Cuál es la plataforma más fácil y gratis para hacer mi primera página web?",
    "Dame los pasos para crear mi web de un negocio de galletas en Google Sites.",
    "Ayúdame a escribir el texto de bienvenida para la web de mi negocio.",
    "¿Cómo reviso con un adulto si un nombre de dominio está libre?",
  ],
  en: [
    "Explain what a domain and hosting are like I'm 8 years old.",
    "What is the easiest free platform to make my first website?",
    "Give me the steps to build a cookie business website in Google Sites.",
    "Help me write the welcome text for my business website.",
    "How do I check with an adult if a domain name is available?",
  ],
};

export const WEB_TEXT = {
  es: {
    title: "Taller web de Spark",
    platforms: "Plataformas recomendadas (de la más fácil a la más pro)",
    free: "Gratis para empezar",
    open: "Visitar con un adulto",
    glossary: "Palabras mágicas de la web",
    gptTitle: "Aprende con ChatGPT",
    gptSub: "Copia una pregunta y pégala en ChatGPT, o pregúntale a Spark aquí mismo.",
    gptNote: "ChatGPT es para mayores de 13 años: si eres menor, úsalo junto a un adulto.",
    copy: "Copiar",
    copied: "¡Pregunta copiada!",
    openGpt: "Abrir ChatGPT",
    askSpark: "Preguntar a Spark",
    domainTitle: "Inventa tu dominio",
    domainPh: "Nombre de tu negocio (ej: Galletas Mágicas)",
    domainNote: "Pídele a un adulto revisar si está libre antes de comprarlo.",
  },
  en: {
    title: "Spark's web workshop",
    platforms: "Recommended platforms (easiest to most pro)",
    free: "Free to start",
    open: "Visit with an adult",
    glossary: "Magic web words",
    gptTitle: "Learn with ChatGPT",
    gptSub: "Copy a question and paste it into ChatGPT, or ask Spark right here.",
    gptNote: "ChatGPT is for ages 13+: if you're younger, use it with an adult.",
    copy: "Copy",
    copied: "Question copied!",
    openGpt: "Open ChatGPT",
    askSpark: "Ask Spark",
    domainTitle: "Invent your domain",
    domainPh: "Your business name (e.g. Magic Cookies)",
    domainNote: "Ask an adult to check it's available before buying.",
  },
};
